module.exports = __webpack_public_path__ + "img/roundBlueCross.41105d47.svg";